import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image';
import * as styles from '../../../sass/layout.module.scss'
import * as stylesS from '../splitNoCtas/noCtaSplits.module.scss'


const noRightctaSplit = ({block, raw}) => {
  const {header,subcontentr,image} = block
  return (
    <section className={stylesS.splitterRight}>
         <div className={styles.layoutBody}>
            
         <div className={stylesS.splitterRightWrap}>
          
            <div className={stylesS.splitterRightImage}>
                {image && image.asset && (
                <GatsbyImage 
                    alt={header} 
                    image={image.asset.gatsbyImageData}>
                </GatsbyImage>
                )}
            </div>
           
            <div className={stylesS.splitterContentRight}>

                <h1>{header}</h1>
                {subcontentr.map(val => {
                        
                        var style = val.style;
                        if(style === 'h1'){
                        return  <h1 className={stylesS.splitLeftText}> {val.children.map((x,j) => {
                                return<span key={j}>{x.text}</span>; })} </h1>;
                        } else  if(style === 'h2'){  
                            return  <h2 className={stylesS.splitLeftText}> {val.children.map((x,j) => {
                                return<span key={j}>{x.text}</span>; })} </h2>;

                        } else  if(style === 'h3'){ 
                            return  <h3 className={stylesS.splitLeftText}> {val.children.map((x,j) => {
                                return<span key={j}>{x.text}</span>; })} </h3>;

                        } else  if(style === 'h4'){ 
                            return  <h4 className={stylesS.splitLeftText}> {val.children.map((x,j) => {
                                return<span key={j}>{x.text}</span>; })} </h4>; 
                        } else  if(style === 'h5'){  

                            return  <h5 className={stylesS.splitLeftText}> {val.children.map((x,j) => {
                                return<span key={j}>{x.text}</span>; })} </h5>;
                        } 
                        else{
                            return  <p className={stylesS.splitLeftText}> {val.children.map((x,j) => {
                                return<span key={j}>{x.text}</span>; })} </p>;
                        }
                        
                        
                        })}

            </div>


        </div>

      </div>

    </section>
  )
}

export default noRightctaSplit